export enum ACCESS_TO_DOCUMENT_TYPES {
  NotSelected = 0,
  InvoiceWithLink = 1,
  InvoiceWithAttachment = 2,
  InvoiceWithAttachmentAndXml = 3,
  InvoiceWithXml = 4,
  InvoiceWithKsefLink = 5,
}
